<div [attr.data-cy]="'metaInfo-' + id" class="d-flex flex-column justify-content-center align-items-center">
	<p class="fs-1 fw-semibold mb-0 text-center" [attr.data-cy]="'metaInfo-value-' + id">{{ value }}</p>
	<p class="fw-semibold text-muted text-center" [attr.data-cy]="'metaInfo-key-' + id">{{ key }}</p>
</div>
